import service from "@/utils/request";

// 新增工资条目
export interface createSalaryItemData {
  type: number;
  name: string;
}
export const createSalaryItemApi = (data: createSalaryItemData) => {
  return service({
    url: "/api/v1/salary/item/create",
    method: "post",
    data,
  });
};
// 修改工资条目状态
export interface setSalaryItemStatusData {
  salary_item_id: number;
  status: number;
}
export const setSalaryItemStatusApi = (data: setSalaryItemStatusData) => {
  return service({
    url: "/api/v1/salary/item/status",
    method: "post",
    data,
  });
};
// 修改工资条目排序
export interface setSalaryItemSortData {
  sort: number;
  salary_item_id: number;
  item_list: any[];
}
export const setSalaryItemSortApi = (data: setSalaryItemSortData) => {
  return service({
    url: "/api/v1/salary/item/sort",
    method: "post",
    data,
  });
};
// 删除工资条目
export interface deleteSalaryItemData {
  salary_item_id: number;
}
export const deleteSalaryItemApi = (data: deleteSalaryItemData) => {
  return service({
    url: "/api/v1/salary/item/del",
    method: "post",
    data,
  });
};
// 工资条目列表
export const getSalaryItemListApi = () => {
  return service({
    url: "/api/v1/salary/item/list",
    method: "get",
  });
};

// 员工工资设置列表
export interface getSalarySettingListData {
  page?: number;
  page_size?: number;
}
export const getSalarySettingListApi = (params: getSalarySettingListData) => {
  return service({
    url: "/api/v1/salary/staff_setting/list",
    method: "get",
    params,
  });
};
// 员工工资设置详情
export interface getSalaryStaffSettingDetailData {
  staff_id: number;
  settle_style?: number;
}
export const getSalaryStaffSettingDetailApi = (
  params: getSalaryStaffSettingDetailData
) => {
  return service({
    url: "/api/v1/salary/staff_setting/detail",
    method: "get",
    params,
  });
};
// 员工工资设置保存
export interface saveSalarySettingData {
  staff_id: number;
  salary_items: {
    salary_item_id: number;
    salary_item_value: string;
  }[];
  group_one_type?: number;
  group_two_type?: number;
  calculate_type?: number;
  performance_gradient?: {
    group_one_id: number;
    range_type: number;
    lesson_price: string;
    price_type: number;
    range: {
      range_start: string;
      range_end: string;
      unit_price: string;
    }[];
  }[];
}
export const saveSalarySettingApi = (data: saveSalarySettingData) => {
  return service({
    url: "/api/v1/salary/staff_setting/save",
    method: "post",
    data,
  });
};
// 机构工资绩效统计规则设置
export interface setSalarySettingPerformanceData {
  group_two_type: number;
  calculate_type: number;
}
export const setSalarySettingPerformanceApi = (
  data: setSalarySettingPerformanceData
) => {
  return service({
    url: "/api/v1/salary/setting/performance",
    method: "post",
    data,
  });
};
// 机构工资绩效到课规则设置
export interface setSalaryExperienceIncludeData {
  experience_lesson_student: number;
}
export const setSalaryExperienceIncludeApi = (
  data: setSalaryExperienceIncludeData
) => {
  return service({
    url: "/api/v1/salary/setting/lessonStudent",
    method: "post",
    data,
  });
};
// 获取机构工资绩效设置详情
export const getSalarySettingDetailApi = () => {
  return service({
    url: "/api/v1/salary/setting/detail",
    method: "get",
  });
};

// 工资结算列表
export interface getSalaryOrderListData {
  page?: number;
  page_size?: number;
  sort_field?: string;
  sort_type?: string;
  name?: string;
  payment_date?: string;
  payment_date_end?: string;
  status?: number;
  task_status_arr?: number[];
  belong_month_start_date?: string;
  belong_month_end_date?: string;
}
export const getSalaryOrderListApi = (data: getSalaryOrderListData) => {
  return service({
    url: "/api/v1/salary/order/list",
    method: "post",
    data,
  });
};
// 工资结算详情
export interface getSalaryOrderDetailData {
  salary_id: number;
}
export const getSalaryOrderDetailApi = (params: getSalaryOrderDetailData) => {
  return service({
    url: "/api/v1/salary/order/detail",
    method: "get",
    params,
  });
};
// 工资结算详情导出
export interface exportSalaryOrderDetailData {
  salary_id: number;
}
export const exportSalaryOrderDetailApi = (
  data: exportSalaryOrderDetailData
) => {
  return service({
    url: "/api/v1/salary/order/detail/export",
    method: "post",
    data,
  });
};
// 工资结算创建
export interface createSalaryOrderData {
  ignore_not_set: boolean;
  name: string;
  start_date: string;
  end_date: string;
  staff_ids: number[];
  payment_date: string;
  belong_month: string;
}
export const createSalaryOrderApi = (data: createSalaryOrderData) => {
  return service({
    url: "/api/v1/salary/order/add",
    method: "post",
    data,
  });
};
// 工资结算删除
export interface deleteSalaryOrderData {
  salary_id: number;
}
export const deleteSalaryOrderApi = (data: deleteSalaryOrderData) => {
  return service({
    url: "/api/v1/salary/order/del",
    method: "post",
    data,
  });
};
// 工资结算确认
export interface confirmSalaryOrderData {
  salary_id: number;
}
export const confirmSalaryOrderApi = (data: confirmSalaryOrderData) => {
  return service({
    url: "/api/v1/salary/order/confirm",
    method: "post",
    data,
  });
};
// 员工工资编辑
export interface editStaffSalaryOrderData {
  salary_sub_id: number;
  item_list: {
    item_id: number;
    amount: string;
  }[];
}
export const editStaffSalaryOrderApi = (data: editStaffSalaryOrderData) => {
  return service({
    url: "/api/v1/salary/order/staff/edit",
    method: "post",
    data,
  });
};
// 员工工资结算绩效详情
export interface getOrderMeritPayDetailData {
  salary_id: number;
  staff_id: number;
}
export const getOrderMeritPayDetailApi = (
  params: getOrderMeritPayDetailData
) => {
  return service({
    url: "/api/v1/salary/order_merit_pay/detail",
    method: "get",
    params,
  });
};
// 员工工资结算绩效课次明细
export interface getOrderMeritPayLessonDetailData {
  salary_id: number;
  staff_id: number;
  group_one_id: number;
  page: number;
  page_size: number;
}
export const getOrderMeritPayLessonDetailApi = (
  params: getOrderMeritPayLessonDetailData
) => {
  return service({
    url: "/api/v1/salary/order_merit_pay/lesson_detail",
    method: "get",
    params,
  });
};

// 教师授课统计
export interface getSalaryTeacherStatisticsData {
  page: number;
  page_size: number;
  name: string;
  lesson_start_date: string;
  lesson_end_date: string;
}
export const getSalaryTeacherStatisticsApi = (
  params: getSalaryTeacherStatisticsData
) => {
  return service({
    url: "/api/v1/salary/teacher_statistics",
    method: "get",
    params,
  });
};
// 教师授课统计导出
export interface exportSalaryTeacherStatisticsData {
  name?: string;
  lesson_start_date: string;
  lesson_end_date: string;
}
export const exportSalaryTeacherStatisticsApi = (
  data: exportSalaryTeacherStatisticsData
) => {
  return service({
    url: "/api/v1/salary/teacher_statistics/export",
    method: "post",
    data,
  });
};
export interface salaryOrderStaffListInter {
  page: number;
  page_size: number;
  key_word?: string;
  belong_month_start_date?: string;
  belong_month_end_date?: string;
  amount_start?: string;
  amount_end?: string;
  is_teach?: number;
}
// 员工工资结算明细列表
export const salaryOrderStaffListApi = (params: salaryOrderStaffListInter) => {
  return service({
    url: "/api/v1/salary/order/staff_list",
    method: "get",
    params,
  });
};
// 员工工资结算明细列表导出
export const salaryOrderStaffListExportApi = (
  params: salaryOrderStaffListInter
) => {
  return service({
    url: "/api/v1/salary/order/staff_list_export",
    method: "get",
    params,
  });
};
